import React, { createContext } from 'react'

export const SupplementalOverlayContext = createContext()

export default function SupplementalOverlayProvider({ portalDiv, ...props }) {
  return <SupplementalOverlayContext.Provider value={portalDiv} {...props} />
}
